import { localisedValue } from "utils"

const clientTypeTransformer = (data) => {
  const clientTypes = []
  const subtypeMap = {}
  let companyId = null
  let individualId = null

  const transformItem = (item) => ({
    ...item,
    key: item.id,
    label: localisedValue({ object: item, key: "name" }),
    value: item.id.toString(),
    slug: item.slug || item.name?.toLowerCase(),
  })

  for (const item of data) {
    if (item?.parentId == null) {
      const slug = item.slug || item.name?.toLowerCase()
      if (slug === "company") companyId = item.id
      else if (slug === "individual") individualId = item.id
      clientTypes.push(transformItem(item))
    } else {
      (subtypeMap[item.parentId] ||= []).push(transformItem(item))
    }
  }

  return {
    clientTypes,
    companySubtypes: subtypeMap[companyId] || [],
    individualSubtypes: subtypeMap[individualId] || [],
  }
}

export default clientTypeTransformer
